<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Assign New Class">
        <v-card-actions>
          <a v-if="!isStaff" @click="$router.back()">
            <v-btn elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          </a>
          <a v-if="isStaff" @click="$router.back()">
            <v-btn elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          </a>
        </v-card-actions>
        <v-card flat class="px-2">
          <form autocomplete="off" @submit.prevent="saveClassDetails">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                Select Class
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete
                placeholder="--Select--"
                class="my-0 py-1"
                name="classSelect"
                v-model="selectedClassID"
                required
                @change="getSectionList(),getFeePlanList()"
                item-value="id"
                :items="classList"
                key="id"
                item-text="name"
                :disabled="setToDisable"
              >
              </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                Section
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete
                placeholder="--Select--"
                class="my-0 py-1"
                name="sectionSelect"
                v-model="selectedSectionID"
                required
                item-value="id"
                :items="classWiseSections"
                key="id"
                item-text="name"
                :disabled="setToDisable"
              >
              </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" >
                <label class="font-weight-medium body-2">
                Assign Fee Plan
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete
                placeholder="--Select--"
                class="my-0 py-1"
                name="feePlanSelect"
                v-model="planID"
                required
                @change="getTableList"
                item-value="id"
                :items="infoArray"
                key="id"
                item-text="name"
                :rules="feePlanRule"
                :disabled="setToDisable"
              >
              </v-autocomplete>
               </v-col>
               <v-col cols="12" v-if="tableInfo.length > 0">
                  <v-card-component>
                    <b-table :checked-rows.sync="checkedRows" :is-row-checkable="row => row.isCompulsory !== true" checkable :striped="true" :hoverable="true" :data="tableInfo || []">
                      <template slot-scope="props">
                        <b-table-column field="Sr No" label="Sr No">{{ props.index + 1 }}</b-table-column>
                        <b-table-column :disabled="!props.row.isCompulsory" field="feeType.name" label="Fee Type">{{ props.row.feeType.name ? props.row.feeType.name : '' }}</b-table-column>
                        <b-table-column :disabled="!props.row.isCompulsory" field="amount" label="Amount">{{ props.row.amount ? props.row.amount : '' }}</b-table-column>
                        <b-table-column :disabled="!props.row.isCompulsory" field="amount" label="Concession Remark">
                          <b-select v-model="props.row.selectedConcessionRemark" placeholder="Select a concession" @input="getDisabled(props.row, props.index)">
                            <option selected value>
                              ----Select---
                            </option>
                            <option v-for="option in props.row.concessionRemark" :value="option.name" :key="option.id">
                              {{ option.name }}
                            </option>
                          </b-select>
                        </b-table-column>

                        <b-table-column field="manualConcAmountPer" label="Concession In Percentage">
                          <input
                            required
                            class="input"
                            :disabled="props.row.isDropdown"
                            placeholder="Concession In Percentage"
                            maxLength="100"
                            :max="100"
                            :min="0"
                            :max-height="600"
                            @input="exceptEValidation($event, props.row)"
                            type="number"
                            v-model="props.row.manualConcAmountPer"
                          />
                        </b-table-column>
                        <b-table-column field="concessionAmount" label="Concession Amount">
                          <input
                            required
                            class="input"
                            :disabled="props.row.isDropdown"
                            placeholder="Concession Amount"
                            maxLength="100"
                            :max="props.row.amount"
                            readonly
                            :max-height="600"
                            type="number"
                            v-model="props.row.manualConcAmount"
                        /></b-table-column>
                      </template>
                      <template slot="empty">
                        <section class="section">
                          <div class="content has-text-grey has-text-centered">
                            <p>
                              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                            </p>
                            <p>Nothing here.</p>
                          </div>
                        </section>
                      </template>
                    </b-table>
                  </v-card-component>
                </v-col>
              <v-col cols="12" >
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" color="primary" type="submit">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                  <v-btn v-if='this.savedClassDetails.pendingOnboardInfo' bottom right elevation="1" color="error" class="button is-danger" @click="cancelOnboarding()">
                    <v-icon left> mdi-cancel </v-icon>
                    Cancel Onboarding
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
          <form v-if='showClassDetails' autocomplete="off" @submit.prevent="onboardedDetails">
            <v-row>
             <v-col cols="12" sm="12" md="12">
                <v-card-actions class="justify-center">
                  <v-btn
                    class="mt-10 mr-5"
                    color="error"
                    small
                    @click="sendLink(savedClassDetails)"
                    :disabled='disableButton'
                  >
                    Fee Payment - Send Link
                  </v-btn>
                <v-btn
                  class="mt-10 mr-5 "
                  color="info"
                  small
                  @click="sendLink(savedClassDetails, true)"
                  :disabled='disableButton'
                >
                  Fee Payment - Offline Pay
                </v-btn>
             </v-card-actions>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                Payment Status
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete
                placeholder="--Select--"
                class="my-0 py-1"
                name="classSelect"
                v-model="selectedPaymentStatus"
                auto-select-first
                required
                item-value="id"
                :items="paymentStatus"
                key="id"
                :disabled="statusDisable"
              >
              </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                Class Start Date
                <span class="requir error--text">*</span>
              </label>
                <custom-date-picker @input="changeClassEndDate()" v-model="classStartDate"/>

              </v-col>
              <v-col cols="12" md="6" >
                <label class="font-weight-medium body-2">
                Class End Date
                <span class="requir error--text">*</span>
              </label>
                <v-text-field class="ml-5 mb-1" v-model="classEndDate" disabled></v-text-field>

               </v-col>
              <v-col cols="12" >
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" color="primary" type="submit">
                    <v-icon left> mdi-content-save </v-icon>
                    Onboard
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
const _ = require('lodash')

export default {
  name: 'SaveUser',
  components: {
    MaterialCard,
    CustomDatePicker,
    VCardComponent
  },
  props: ['studentID'],
  data () {
    return {
      classList: [],
      selectedClassID: '',
      classWiseSections: [],
      selectedSectionID: '',
      planID: '',
      infoArray: [],
      showClassDetails: false,
      paymentStatus: ['Pending', 'Confirmed'],
      selectedPaymentStatus: 'Pending',
      classStartDate: new Date().toISOString().slice(0, 10),
      classEndDate: moment().add(60, 'days').format('YYYY-MM-DD'),
      tableInfo: [],
      feePlanRule: [v => !!v || ' Fee plan is required'],
      sendLinkDialog: false,
      selectedclassName: '',
      sections: [],
      sectionID: '',
      hasClicked: false,
      isParent: true,
      savedClassDetails: [],
      isLoading: false,
      isStaff: false,
      loadingComponent: null,
      setToDisable: false,
      disableButton: false,
      statusDisable: false
    }
  },

  async created () {
    this.getSavedClassDetails()
  },
  methods: {
    getClassList: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/mother-toddler/class/list`)
        this.classList = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching class list', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getSectionList: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/students/section/${this.selectedClassID}`)
        this.classWiseSections = response.data.studentSections
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching section list', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getFeePlanList: async function () {
      try {
        this.isLoading = true
        let formData = {
          admissionID: this.savedClassDetails.oldAdmission.id,
          classID: this.selectedClassID
        }
        const response = await http.post(`${constants.API_URL}/api/get-fee-plans`, formData)
        this.infoArray = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching fee plan list', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    saveClassDetails: async function () {
      try {
        if (!this.selectedClassID) {
          return this.$dialog.error({
            text: `Please select Class`,
            title: 'Error'
          })
        } else if (!this.selectedSectionID) {
          return this.$dialog.error({
            text: `Please select section`,
            title: 'Error'
          })
        } else if (!this.planID) {
          return this.$dialog.error({
            text: `Please select fee plan`,
            title: 'Error'
          })
        }
        let formData = {
          feeComponentID: this.planID,

          feeType: _.map(this.checkedRows, item => {
            let obj = {
              id: item.id,
              feeConcessionID: item.concessionID,
              concessionAmount: item.manualConcAmount
            }
            if (item.selectedConcessionRemark) {
              obj.concessionRemark = item.selectedConcessionRemark
            }
            return obj
          })
        }

        formData.admissionID = this.savedClassDetails.oldAdmission.id
        formData.classID = this.selectedClassID
        formData.sectionID = this.selectedSectionID

        if (this.concessionID) {
          formData.feeConcessionID = this.concessionID
        }

        this.loadingComponent = this.$buefy.loading.open()

        await http.post(`${constants.API_URL}/api/mother-toddler/detail/assign-fee-plan`, formData)

        this.loadingComponent.close()
        this.showClassDetails = true
        this.okMsg('Saved Successfully')
        location.reload()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      }
    },
    cancelOnboarding: async function (orderID) {
      this.$buefy.dialog.confirm({
        title: 'Confirm Onboarding',
        message: 'Are you sure you want to cancel this onboarding process?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            this.isLoading = true
            let res = await http.put(`${constants.API_URL}/api/mother-toddler/onboard/cancel/${this.savedClassDetails.pendingOnboardInfo.id}`)
            console.log(res, 'res')
            this.okMsg('Onboarding cancelled successfully!')
            this.$router.push({ name: 'viewMotherToddlerProgram' })
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            this.errMsg(errorMessage)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    changeClassEndDate: async function () {
      if (this.classStartDate) {
        this.classEndDate = moment(this.classStartDate).add(60, 'days').format('YYYY-MM-DD')
      } else {
        this.classEndDate = null
      }
    },
    getTableList: async function () {
      this.checkedRows = []
      if (this.planID) {
        _.map(this.infoArray, item => {
          if (item.id === this.planID) {
            this.tableInfo = item.feeComponentFeeTypeMaps
          }
        })
      } else {
        this.tableInfo = []
      }
      _.map(this.tableInfo, element => {
        element.concessionRemark = [
          { id: 1, name: 'Sibling Concession' },
          { id: 2, name: 'Staff Concession' },
          { id: 3, name: 'One-shot Payment Concession' },
          { id: 4, name: 'Referral Concession' },
          { id: 5, name: 'General / Other Concession' }
        ]
        element.selectedConcessionRemark = ''
        element.isDropdown = true
        if (element.isCompulsory === true) {
          this.checkedRows.push(element)
        }
      })
    },
    getDisabled: function (item, index) {
      let udatedData = item
      if (item.selectedConcessionRemark) {
        udatedData.isDropdown = false
      } else {
        udatedData.isDropdown = true
        udatedData.manualConcAmount = 0
        udatedData.manualConcAmountPer = 0
      }
      udatedData.manualConcAmount = 0
      this.tableInfo.splice(index, 1, udatedData)
    },
    exceptEValidation: function (event, item) {
      let amountPer = event.target.value
      if (amountPer < 0) {
        amountPer = 0
      } else if (amountPer > 100) {
        amountPer = 100
      }
      item.manualConcAmountPer = amountPer
      item.manualConcAmount = ((item.amount * amountPer) / 100).toFixed(2)
    },
    getSavedClassDetails: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/mother-toddler/onboard/pending/${this.studentID}`)
        this.savedClassDetails = response.data
        if (this.savedClassDetails.pendingOnboardInfo) {
          this.setToDisable = true
          this.getClassList()
          this.selectedClassID = this.savedClassDetails.pendingOnboardInfo.studentAdmission.classID
          this.selectedSectionID = this.savedClassDetails.pendingOnboardInfo.studentAdmission.sectionID
          this.planID = this.savedClassDetails.pendingOnboardInfo.assignFeeComponentActive.assignFeeComponent.feeComponentID
          this.getSectionList()
          this.getFeePlanList()
          this.showClassDetails = true
        } else {
          this.getClassList()
        }
        if (this.savedClassDetails.paymentData) {
          if (this.savedClassDetails.paymentData.mode === 'ONLINE') {
            this.statusDisable = true
            this.selectedPaymentStatus = this.savedClassDetails.paymentData.status
          } else {
            this.statusDisable = false
          }
          if (this.savedClassDetails.paymentData.status === 'Confirmed') {
            this.disableButton = true
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    sendLink: async function (item, isOffline = false) {
      try {
        this.isLoading = true
        const response = await http.post(
          `${constants.API_URL}/api/mother-toddler/payments/generate-link`,
          {
            admissionID: item.pendingOnboardInfo.studentAdmissionID,
            mode: isOffline ? 'OFFLINE' : 'ONLINE'
          }
        )
        if (isOffline) {
          let route = this.$router.resolve({
            name: 'OfflinePayments',
            params: { referenceID: response.data }
          })
          window.open(route.href, '_blank')
        } else {
          return this.$dialog.info({
            text: `Payment Link Sent on Mail`,
            title: 'Success'
          })
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    onboardedDetails: async function () {
      try {
        let formData = {
          paymentStatus: this.selectedPaymentStatus,
          classStartDate: this.classStartDate,
          classEndDate: this.classEndDate
        }
        await http.put(`${constants.API_URL}/api/mother-toddler/onboard/confirm/${this.savedClassDetails.pendingOnboardInfo.id}`, formData)

        this.okMsg('Onboarded Successfully')
        this.$router.push({ name: 'viewMotherToddlerProgram' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
